import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { isNull, isUndefined } from 'lodash';

export const useSessionStorage = <T>(
  key: string,
  initialValue?: T
): [T, Dispatch<SetStateAction<T>>] => {
  const [state, setState] = useState(() => {
    try {
      const item = window.sessionStorage.getItem(key);

      if (item) {
        return JSON.parse(item);
      }
    } catch (error) {
      console.log(error);
      return initialValue;
    }

    return initialValue;
  });

  useEffect(() => {
    // NOTE: this is a fallback in case a initialValue is not provided this setting the sessionstrorage value to `undefined`
    if (!isNull(state) && !isUndefined(state)) {
      try {
        window.sessionStorage.setItem(key, JSON.stringify(state));
      } catch (error) {
        console.log(error);
      }
    }
  }, [state, key]);

  return [state, setState];
};
